import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import topImg from './modules/topImg';
import * as getters from './getters';
import { actions } from './actions';

Vue.use(Vuex);

export default new Vuex.Store({
  getters,
  actions,
  // 各模块对应的 state 根节点为 /state/{module-name}
  modules: {
    app,
    topImg,
  },
  strict: false
});



// WEBPACK FOOTER //
// ./src/vuex/store.js